import './index.scss';
import React from 'react';
import { observer } from 'mobx-react';
import { uniqBy } from 'lodash';
import { Button, Form, Checkbox, Select } from 'semantic-ui-react';

import Modal from '../../shared/Modal';
import customFetch from '../../../utils/customFetch';
import DoctorReportsStore from './DoctorReportsStore';
import { DatePicker, Spin } from 'antd';
import ModalVerifyAccessCode from './ModalVerifyAccessCode';

const DoctorLabels = [
  { text: `ACT`, value: `ACT` },
  { text: `NSW`, value: `NSW` },
  { text: `VIC`, value: `VIC` },
  { text: `QLD`, value: `QLD` },
  { text: `SA`, value: `SA` },
  { text: `WA`, value: `WA` },
  { text: `TAS`, value: `TAS` },
  { text: `NT`, value: `NT` },
];

const datePickerFormat = 'DD/MM/YYYY';

@observer
class ModalExport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpenAccessCodeModal: false,
      exported: [],
      speItemList: [],
      accreditationList: [],
      industryExpertTypeList: [],
      DateFrom: null,
      DateTo: null,
      loading: true,
      IncludeRecruitingDoctors: true,
      IncludeOnboardingDoctors: true,
      IncludeOnboardedDoctors: true,
      IncludeNCIDoctors: true,
      Inactive: false,
      doctorTypes1: '',
      doctorTypes2: '',
      doctorTypes3: '',
      acceptTeleAssessment: true,
      notAcceptTeleAssessment: true,
      unsureTeleAssessment: true,
      selectedSpecialties: [],
      selectedAccreditations: [],
      selectedIndustryExpertTypes: [],
      state: '',
      subscribedPromotionStatus: true,
      unSubscribedPromotionStatus: false,
    };
  }
  async componentDidMount() {
    try {
      const exportPromise = customFetch('/MedicalDoctor/GetLookUpConfig', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ type: 'doctor' }),
      });

      const [exportDoctor] = await Promise.all([exportPromise]);

      this.setState({
        speItemList: uniqBy(exportDoctor.speItemList),
        exported: exportDoctor,
        accreditationList: uniqBy(exportDoctor.accreditationList),
        industryExpertTypeList: uniqBy(exportDoctor.industryExpertTypeList),
      });
    } finally {
      this.setState({ loading: false });
    }
  }

  renderSpeFilterOptions = () => {
    return this.state.speItemList.map(opt => ({
      text: opt.Label,
      value: opt.Id,
    }));
  };

  renderSpeFilterText = () => {
    let labels = this.state.selectedSpecialties.map(opt => {
      const matchItem = this.state.speItemList.find(i => i.Id === opt);
      if (matchItem) {
        return matchItem.Id;
      }
      return opt;
    });
    return labels;
  };
  renderAccreditationFilterOptions = () => {
    return this.state.accreditationList.map(opt => ({
      text: opt.Label,
      value: opt.Label,
    }));
  };

  renderAccreditationFilterText = () => {
    let labels = this.state.selectedAccreditations.map(opt => {
      const matchItem = this.state.accreditationList.find(i => i.Id === opt);
      if (matchItem) {
        return matchItem.Id;
      }
      return opt;
    });
    return labels;
  };

  renderIndustryExpertTypeFilterOptions = () => {
    return this.state.industryExpertTypeList.map(opt => ({
      text: opt.Label,
      value: opt.Id,
    }));
  };

  renderIndustryExpertTypeFilterText = () => {
    let labels = this.state.selectedIndustryExpertTypes.map(opt => {
      const matchItem = this.state.industryExpertTypeList.find(i => i.Id === opt);
      if (matchItem) {
        return matchItem.Id;
      }
      return opt;
    });
    return labels;
  };

  renderDoctorFilterOptions = () => {
    return DoctorLabels.map(opt => ({
      text: opt.text,
      value: opt.value,
    }));
  };

  renderDoctorFilterText = value => {
    let labels = DoctorLabels.filter(opt => opt.value === value).map(opt => opt.text);
    return labels[0];
  };

  onChangeCheckBoxFalse = name => {
    this.setState({
      ...this.state,
      [name]: false,
    });
  };

  onChangeCheckBox = (name, value) => {
    this.setState({
      ...this.state,
      [name]: true,
    });
  };

  handlePickerChange = name => momentValue => {
    this.setState({
      ...this.state,
      [name]: momentValue.format('DDMMMMYYYY'),
    });
  };
  handleOnChangeDropDown = (_, { name, value }) => {
    this.setState({ [name]: value });
  };

  handleOnChangeAccDropDown = (e, { value }) => {
    this.setState({ ...this.state, selectedAccreditations: value });
  };

  renderIndustryType = arrayId => {
    const matchItem = [];
    // const matchItem = arrayId
    //   .map(id =>
    //     DoctorDetailsStore.dataLookupConfig.indItemList.find(i => i.Id === id),
    //   )
    //   .map(i => i.Label);
    return matchItem;
  };

  openModal = options => {
    this.setState({ isActive: false });
    return DoctorReportsStore.toggleModal(true, options)();
  };

  handleExport = () => {
    const {
      IncludeRecruitingDoctors,
      IncludeOnboardingDoctors,
      IncludeOnboardedDoctors,
      IncludeNCIDoctors,
      Inactive,
      DateFrom,
      DateTo,
      doctorTypes1,
      doctorTypes2,
      doctorTypes3,
      acceptTeleAssessment,
      notAcceptTeleAssessment,
      unsureTeleAssessment,
      state,
    } = this.state;
    const doctorTypes = [];
    if (doctorTypes1) {
      doctorTypes.push(doctorTypes1);
    }
    if (doctorTypes2) {
      doctorTypes.push(doctorTypes2);
    }
    if (doctorTypes3) {
      doctorTypes.push(doctorTypes3);
    }
    const params = Object.assign(
      {},
      {
        from: DateFrom,
        to: DateTo,
        IncludeRecruitingDoctors: IncludeRecruitingDoctors,
        IncludeOnboardingDoctors: IncludeOnboardingDoctors,
        IncludeOnboardedDoctors: IncludeOnboardedDoctors,
        IncludeNCIDoctors: IncludeNCIDoctors,
        Inactive: Inactive,
        acceptTeleAssessment: acceptTeleAssessment,
        notAcceptTeleAssessment: notAcceptTeleAssessment,
        unsureTeleAssessment: unsureTeleAssessment,
        SubscribedPromotionStatus: this.state.subscribedPromotionStatus,
        UnsubscribedPromotionStatus: this.state.unSubscribedPromotionStatus,
        state: state,
      },
    );
    var qs = Object.entries(params)
      .map(([key, val]) => `${key}=${val}`)
      .join('&');
    var qs1 = doctorTypes.map(val => `doctorTypes=${val}`).join('&');
    var qs2 = this.state.selectedSpecialties.map(val => `speList=${val}`).join('&');
    var qs3 = this.state.selectedAccreditations.map(val => `accList=${val.replace(/\s+/g, '+')}`).join('&');
    var qs4 = this.state.selectedIndustryExpertTypes.map(val => `ExpertTypeList=${val}`).join('&');

    var queryParams = qs + '&' + qs1 + '&' + qs2 + '&' + qs3 + '&' + qs4;
    DoctorReportsStore.setFieldsValue({ exportUrl: '/Report/ExportDoctor', exportQueryParams: queryParams });

    this.setState({ ...this.state, isOpenAccessCodeModal: true });
  };

  onCancel = () => {
    this.props.onCancel();
  };
  render() {
    const { open } = DoctorReportsStore;
    const {
      exported,
      loading,
      IncludeRecruitingDoctors,
      IncludeOnboardingDoctors,
      IncludeOnboardedDoctors,
      IncludeNCIDoctors,
      Inactive,
    } = this.state;
    return (
      <React.Fragment>
        {loading && !exported.length ? (
          <Spin size="large" className="modal-spin" />
        ) : (
          <Modal
            visible={open}
            width={900}
            onCancel={this.props.onCancel}
            footer={
              <React.Fragment>
                <Button color="blue" onClick={this.handleExport}>
                  Export
                </Button>
                <Button color="red" onClick={this.onCancel}>
                  Close
                </Button>
              </React.Fragment>
            }
            title="Export Specialist List"
          >
            <Form className="export-specialist">
              <div className="field-date">
                <Form.Field
                  control={DatePicker}
                  label="Created from"
                  style={{ width: 250 }}
                  allowClear={false}
                  format={datePickerFormat}
                  onChange={this.handlePickerChange('DateFrom')}
                />
                <Form.Field
                  control={DatePicker}
                  label="To"
                  style={{ width: 250 }}
                  allowClear={false}
                  format={datePickerFormat}
                  onChange={this.handlePickerChange('DateTo')}
                />
              </div>
              <Form.Dropdown
                fluid
                multiple
                search
                selection
                id="form-input-first-name"
                label={{
                  children: 'Filter by Specialty',
                  htmlFor: 'form-select-control-gender',
                }}
                name="selectedSpecialties"
                placeholder="Select Specialty"
                value={this.renderSpeFilterText()}
                options={this.renderSpeFilterOptions()}
                onChange={this.handleOnChangeDropDown}
              />
              <Form.Dropdown
                fluid
                multiple
                search
                selection
                name="selectedAccreditations"
                id="form-input-first-name"
                label={{
                  children: 'Filter by Accreditations',
                  htmlFor: 'form-select-control-gender',
                }}
                placeholder="Select accreditation"
                value={this.renderAccreditationFilterText()}
                options={this.renderAccreditationFilterOptions()}
                onChange={this.handleOnChangeDropDown}
              />
              <p className="label-title">Filter by Recruitment Status</p>
              <div className="field-checkbox" style={{ marginBottom: 10 }}>
                <Checkbox
                  defaultChecked={IncludeRecruitingDoctors ? true : false}
                  label="Recruiting"
                  onChange={
                    IncludeRecruitingDoctors
                      ? () => this.onChangeCheckBoxFalse('IncludeRecruitingDoctors')
                      : () => this.onChangeCheckBox('IncludeRecruitingDoctors')
                  }
                />
                <Checkbox
                  defaultChecked={IncludeOnboardingDoctors ? true : false}
                  label="Onboarding"
                  onChange={
                    IncludeOnboardingDoctors
                      ? () => this.onChangeCheckBoxFalse('IncludeOnboardingDoctors')
                      : () => this.onChangeCheckBox('IncludeOnboardingDoctors')
                  }
                />
                <Checkbox
                  defaultChecked={IncludeOnboardedDoctors ? true : false}
                  label="Onboarded"
                  onChange={
                    IncludeOnboardedDoctors
                      ? () => this.onChangeCheckBoxFalse('IncludeOnboardedDoctors')
                      : () => this.onChangeCheckBox('IncludeOnboardedDoctors')
                  }
                />
                <Checkbox
                  defaultChecked={IncludeNCIDoctors ? true : false}
                  label="NCI"
                  onChange={
                    IncludeNCIDoctors
                      ? () => this.onChangeCheckBoxFalse('IncludeNCIDoctors')
                      : () => this.onChangeCheckBox('IncludeNCIDoctors')
                  }
                />
                <Checkbox
                  defaultChecked={Inactive ? true : false}
                  label="Inactive"
                  onChange={
                    Inactive ? () => this.onChangeCheckBoxFalse('Inactive') : () => this.onChangeCheckBox('Inactive')
                  }
                />
              </div>
              <Form.Field
                control={Select}
                label={{
                  children: 'Filter by Office State:',
                  htmlFor: 'form-select-control-gender',
                }}
                placeholder="Select State:"
                search
                name="state"
                searchInput={{ id: 'form-select-control-gender' }}
                value={this.state.state}
                options={this.renderDoctorFilterOptions()}
                onChange={this.handleOnChangeDropDown}
              />
              <p className="label-title">Filter by Registered Type</p>
              <div className="field-checkbox" style={{ marginBottom: 10 }}>
                <Checkbox
                  label="P"
                  onChange={
                    this.state.doctorTypes1
                      ? () => this.onChangeCheckBoxFalse('doctorTypes1')
                      : () => this.onChangeCheckBox('doctorTypes1', 'P')
                  }
                />
                <Checkbox
                  label="D"
                  onChange={
                    this.state.doctorTypes2
                      ? () => this.onChangeCheckBoxFalse('doctorTypes2')
                      : () => this.onChangeCheckBox('doctorTypes2', 'D')
                  }
                />
                <Checkbox
                  label="P&D"
                  onChange={
                    this.state.doctorTypes3
                      ? () => this.onChangeCheckBoxFalse('doctorTypes3')
                      : () => this.onChangeCheckBox('doctorTypes3', 'P%26D')
                  }
                />
                <div className="ui checkbox"></div>
              </div>
              <Form.Dropdown
                fluid
                multiple
                search
                selection
                name="selectedIndustryExpertTypes"
                id="form-input-first-name"
                label={{
                  children: 'Filter by Service Type',
                  htmlFor: 'form-select-control-gender',
                }}
                placeholder="Select service type"
                value={this.renderIndustryExpertTypeFilterText()}
                options={this.renderIndustryExpertTypeFilterOptions()}
                onChange={this.handleOnChangeDropDown}
              />
              <p className="label-title">Accept video assessments</p>
              <div>
                <Checkbox
                  label="Yes"
                  checked={this.state.acceptTeleAssessment}
                  onChange={() => this.setState({ acceptTeleAssessment: !this.state.acceptTeleAssessment })}
                />
                <Checkbox
                  style={{ marginLeft: '10px' }}
                  label="No"
                  checked={this.state.notAcceptTeleAssessment}
                  onChange={() => this.setState({ notAcceptTeleAssessment: !this.state.notAcceptTeleAssessment })}
                />
                <Checkbox
                  style={{ marginLeft: '10px' }}
                  label="Unsure"
                  checked={this.state.unsureTeleAssessment}
                  onChange={() => this.setState({ unsureTeleAssessment: !this.state.unsureTeleAssessment })}
                />
              </div>
              <p className="label-title">Promotion Campaign Status</p>
              <div style={{ marginTop: 10 }}>
                <Checkbox
                  label="Subscribed"
                  checked={this.state.subscribedPromotionStatus}
                  onChange={() => this.setState({ subscribedPromotionStatus: !this.state.subscribedPromotionStatus })}
                />
                <Checkbox
                  style={{ marginLeft: '10px' }}
                  label="Unsubscribed"
                  checked={this.state.unSubscribedPromotionStatus}
                  onChange={() =>
                    this.setState({ unSubscribedPromotionStatus: !this.state.unSubscribedPromotionStatus })
                  }
                />
              </div>
              {this.state.isOpenAccessCodeModal && (
                <ModalVerifyAccessCode {...DoctorReportsStore} onCancel={DoctorReportsStore.toggleModal(false)} />
              )}
            </Form>
          </Modal>
        )}
      </React.Fragment>
    );
  }
}

export default ModalExport;
